/**
 * rikaikun — Japanese-English popup dictionary
 *
 * Declares a single web-accessible-resource: `css/popup.css`, matched to every origin
 * with no `use_dynamic_url` — so the popup stylesheet is fetchable from any page at a
 * fixed URL.
 *
 * With only one WAR and no bundled icons, detection rests on that single path; it is
 * served only when the extension is installed, which makes it conclusive.
 *
 * Manifest verified against version 3.2.34.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jipdnfibhldikgcjhfnomkfpcebammhp';

export const rikaikun: ExtensionDefinition = {
  id: ID,
  name: 'rikaikun',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Exposes a single static WAR (css/popup.css) to every origin with no dynamic URL. ' +
    'Detection is one fetch and conclusive.',
  signals: [
    {
      id: 'war-popup-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/popup.css — the only web-accessible resource, exposed to every ' +
        'origin and served only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'css/popup.css'),
    },
  ],
};
